var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 374,
    height: 399,
    viewBox: "0 0 374 399",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M223.5 58.2127C268.462 138.041 284.584 102.341 322.687 130.604C360.791 158.866 282.263 344.336 172.763 365.337C102.263 329.337 109.41 333.494 71.3069 305.232C33.2035 276.969 152.518 -67.8139 223.5 58.2127Z",
    fill: "#8E4DFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M323.828 22.0756C329.641 41.9539 344.036 91.1816 300.734 103.844C275.29 111.284 242.654 76.2462 236.841 56.3679C231.028 36.4896 248.627 20.1024 274.071 12.6622C299.515 5.22188 318.015 2.19735 323.828 22.0756Z",
    fill: "#8E4DFF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup1);
export default __webpack_public_path__ + "static/media/Group 1.b9dde41044169d68520424e90d1d94d9.svg";
export { ForwardRef as ReactComponent };